var map = {
	"./error.en.yaml": 3819,
	"./error.es.yaml": 7882,
	"./error.fr.yaml": 631,
	"./error.it.yaml": 9386,
	"./messages.en.yaml": 5072,
	"./messages.es.yaml": 7816,
	"./messages.fr.yaml": 4862,
	"./messages.it.yaml": 3872,
	"./toast.en.yaml": 2501,
	"./toast.es.yaml": 6234,
	"./toast.fr.yaml": 4870,
	"./toast.it.yaml": 8432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4481;